import { render } from "./Knowledgebase.vue?vue&type=template&id=65e9c165&scoped=true"
import script from "./Knowledgebase.vue?vue&type=script&lang=js"
export * from "./Knowledgebase.vue?vue&type=script&lang=js"

import "./Knowledgebase.vue?vue&type=style&index=0&id=65e9c165&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65e9c165"

export default script